import { html } from 'lit';
export const landCategoryUrlParams = [
    'wanderlandetappennational',
    'wanderlandetappenregional',
    'wanderlandetappenlokal',
    'wanderlandetappenhandicap',
    'wanderwegnetz',
    'velolandetappennational',
    'velolandetappenregional',
    'velolandetappenlokal',
    'mtblandetappennational',
    'mtblandetappenregional',
    'mtblandetappenlokal',
    'mtblandtrails',
    'skatinglandetappennational',
    'skatinglandetappenregional',
    'skatinglandetappenlokal',
    'kanulandetappennational',
    'kanulandetappenregional',
    'crosscountryetappenlokal',
    'crosscountrynetwork',
    'winterhikingnetwork',
    'winterhikingetappenlokal',
    'snowshoenetwork',
    'snowshoeetappenlokal',
    'velonetwork',
    'mtbnetwork',
    'skatenetwork',
    'velonetwork_surface',
    'mtbnetwork_surface',
    'skatenetwork_surface',
    'velonetwork_grade',
    'mtbnetwork_grade',
    'skatenetwork_grade',
];
export const LAND_CATEGORIES = {
    wanderland: [
        'WanderlandEtappenNational',
        'WanderlandEtappenRegional',
        'WanderlandEtappenLokal',
        'WanderlandEtappenHandicap',
        'Wanderwegnetz',
    ],
    veloland: [
        'VelolandEtappenNational',
        'VelolandEtappenRegional',
        'VelolandEtappenLokal',
    ],
    mtbland: [
        'MtblandEtappenNational',
        'MtblandEtappenRegional',
        'MtblandEtappenLokal',
        'MtblandTrails',
    ],
    skatingland: [
        'SkatinglandEtappenNational',
        'SkatinglandEtappenRegional',
        'SkatinglandEtappenLokal',
    ],
    kanuland: ['KanulandEtappenNational', 'KanulandEtappenRegional'],
    crosscountry: ['CrosscountryEtappenLokal', 'CrosscountryNetwork'],
    snowshoe: ['SnowshoeEtappenLokal', 'SnowshoeNetwork'],
    winterhiking: ['WinterhikingEtappenLokal', 'WinterhikingNetwork'],
};
export const summerLandLayers = [
    'wanderland',
    'veloland',
    'mtbland',
    'skatingland',
    'kanuland',
];
export const winterLandLayers = [
    'winterhiking',
    'snowshoe',
    'crosscountry',
    'sledging',
];
export const multiLandLayers = [
    ...summerLandLayers,
    'crosscountry',
    'winterhiking',
    'snowshoe',
];
export const summerNetworkLayers = [
    'wanderwegnetz',
    'velonetwork',
    'mtbnetwork',
    'skatenetwork',
];
export const activityNetworkLayers = [
    'velonetwork',
    'mtbnetwork',
    'skatenetwork',
];
export const summerLandCodes = [
    'hike',
    'cycle',
    'mountainbike',
    'skate',
    'canoe',
];
export const winterLandCodes = [
    'crosscountry',
    'winterhike',
    'snowshoe',
    'sledge',
];
export const landCodeToActivity = {
    hike: 'wander',
    cycle: 'velo',
    mountainbike: 'mountain_biking',
    skate: 'skating',
    canoe: 'canoeing',
    crosscountry: 'cross_country_skiing',
    winterhike: 'winter_hiking',
    snowshoe: 'snowshoe_trekking',
    sledge: 'sledging',
};
export const alternativeLandCodes = ['mountainbikeland', 'mtb'];
export const legacyLandCodes = [
    'wander',
    'velo',
    'mountainbike',
    'skating',
    'kanu',
    'winterhiking',
    'snowshoe',
    'crosscountry',
    'sledging',
];
export const POILayersInfo = [
    {
        title: () => 'Public transport',
        icon: 'bg-[url("./src/img/i_transport.svg")]',
        winter: true,
        summer: true,
        code: 'station',
    },
    {
        title: () => 'Accommodation',
        icon: 'bg-[url("./src/img/i_accommodation.svg")]',
        winter: true,
        summer: true,
        code: 'accommodation',
    },
    {
        title: () => 'Places',
        icon: 'bg-[url("./src/img/i_places.svg")]',
        winter: true,
        summer: true,
        code: 'place',
    },
    {
        title: () => 'Places of interest',
        icon: 'bg-[url("./src/img/i_sightseeing.svg")]',
        winter: true,
        summer: true,
        code: 'sightseeing',
    },
    {
        title: () => 'Bicycle and e-bike rental',
        icon: 'bg-[url("./src/img/i_bicycle.svg")]',
        winter: false,
        summer: true,
        code: 'velorental',
    },
    {
        title: () => 'Cycle service',
        icon: 'bg-[url("./src/img/i_service.svg")]',
        winter: false,
        summer: true,
        code: 'cycleservice',
    },
    {
        title: () => 'Swiss Parks',
        icon: 'bg-[url("./src/img/i_swissparks.svg")]',
        winter: true,
        summer: true,
        code: 'swisspark',
    },
    {
        title: () => 'Livestock guardian dogs',
        icon: 'bg-[url("./src/img/i_alpguarddogs.svg")]',
        winter: false,
        summer: true,
        code: 'alpguarddog',
    },
    {
        title: () => 'Designated wildlife areas',
        icon: 'bg-[url("./src/img/i_wildlife.svg")]',
        winter: true,
        summer: false,
        code: 'wildlife',
    },
    {
        title: () => 'Slope over 30°',
        icon: 'bg-[url("./src/img/i_slope.svg")]',
        winter: true,
        summer: true,
        code: 'slope',
    },
    {
        title: () => 'Snow Depth',
        icon: 'bg-[url("./src/img/i_snowdepth.svg")]',
        winter: true,
        summer: true,
        code: 'snowdepth',
    },
].filter((v) => v);
export const HiddenLayersInfo = [
    { title: () => 'slowUp', winter: true, summer: true, code: 'slowup' },
    {
        title: () => 'Municipalities',
        winter: true,
        summer: true,
        code: 'municipalities',
    },
    { title: () => 'Cantons', winter: true, summer: true, code: 'cantons' },
];
export const baseLayerCodes = ['pk', 'pkg', 'lb'];
export const BackgroundLayersInfo = [
    {
        title: () => 'Map in colour',
        icon: 'bg-[url("./src/img/i_map_color.svg")]',
        code: 'pk',
    },
    {
        title: () => 'Map grey',
        icon: 'bg-[url("./src/img/i_map_grey.svg")]',
        code: 'pkg',
    },
    {
        title: () => 'Aerial view',
        icon: 'bg-[url("./src/img/i_map_aerial.svg")]',
        code: 'lb',
    },
];
export const AdditionalRouteLayersInfo = [
    {
        title: () => 'Route numbers',
        icon: 'bg-[url("./src/img/i_route_nr.svg")]',
        code: 'logos',
    },
    {
        title: () => 'Photos',
        icon: 'bg-[url("./src/img/i_photos.svg")]',
        code: 'photos',
    },
    {
        title: () => 'Closure / Detour',
        icon: 'bg-[url("./src/img/i_detour.svg")]',
        codes: ['detours', 'shooting'],
    },
];
export const routeCategoryCodes = [
    'national',
    'regional',
    'local',
    'handicap',
    'trails',
];
const winterCategories = ['local'];
const nationalRegional = ['national', 'regional'];
const nationalRegionalLocal = [
    ...nationalRegional,
    'local',
];
const nationalRegionalLocalTrails = [
    ...nationalRegionalLocal,
    'trails',
];
export const ROUTE_LAYERS = {
    hike: {
        legacyLandCode: 'wander',
        logoFilename: 'logos_wander_segment.geojson',
        season: 'summer',
        colorClass: 'bg-hike',
        pageColorClass: 'bg-page-hike',
        logoClass: 'bg-[url("./src/img/logo_wl.svg")]',
        landCode: 'hike',
        layer: 'wanderland',
        getTitle: () => html `Hiking<br />in Switzer&#8203;land`,
        getTitleNoHyphen: () => html `Hiking<br />in Switzer&#8203;land`,
        getFlatTitle: () => 'Hiking in Switzerland',
        getLayerHintTitle: () => 'Hiking in Switzerland routes',
        categories: [...nationalRegionalLocal, 'handicap'],
        colorRGB: '#609E26',
    },
    cycle: {
        legacyLandCode: 'velo',
        logoFilename: 'logos_velo_segment.geojson',
        season: 'summer',
        colorClass: 'bg-cycle',
        pageColorClass: 'bg-page-cycle',
        logoClass: 'bg-[url("./src/img/logo_vl.svg")]',
        landCode: 'cycle',
        layer: 'veloland',
        getTitle: () => html `Cycling<br />in Switzer&#8203;land`,
        getTitleNoHyphen: () => html `Cycling<br />in Switzer&#8203;land`,
        getFlatTitle: () => 'Cycling in Switzerland',
        getLayerHintTitle: () => 'Cycling in Switzerland routes',
        categories: nationalRegionalLocal,
        colorRGB: '#5C94CF',
    },
    mountainbike: {
        legacyLandCode: 'mountainbike',
        logoFilename: 'logos_mountainbike_segment.geojson',
        season: 'summer',
        colorClass: 'bg-mountainbike',
        pageColorClass: 'bg-page-mountainbike',
        logoClass: 'bg-[url("./src/img/logo_ml.svg")]',
        landCode: 'mountainbike',
        layer: 'mtbland',
        getTitle: () => html `Mountain&#8203;biking<br />in Switzer&#8203;land`,
        getTitleNoHyphen: () => html `Mountain&#8203;biking<br />in Switzer&#8203;land`,
        getFlatTitle: () => 'Mountainbiking in Switzerland',
        getLayerHintTitle: () => 'Mountainbiking in Switzerland routes',
        categories: nationalRegionalLocalTrails,
        colorRGB: '#DEAB18',
    },
    skate: {
        legacyLandCode: 'skating',
        logoFilename: 'logos_skating_segment.geojson',
        season: 'summer',
        colorClass: 'bg-skate',
        pageColorClass: 'bg-page-skate',
        logoClass: 'bg-[url("./src/img/logo_sl.svg")]',
        landCode: 'skate',
        layer: 'skatingland',
        getTitle: () => html `Skating<br />in Switzer&#8203;land`,
        getTitleNoHyphen: () => html `Skating<br />in Switzer&#8203;land`,
        getFlatTitle: () => 'Skating in Switzerland',
        getLayerHintTitle: () => 'Skating in Switzerland routes',
        categories: nationalRegionalLocal,
        colorRGB: '#9D7FB7',
    },
    canoe: {
        legacyLandCode: 'kanu',
        logoFilename: 'logos_kanu_segment.geojson',
        season: 'summer',
        colorClass: 'bg-canoe',
        pageColorClass: 'bg-page-canoe',
        logoClass: 'bg-[url("./src/img/logo_kl.svg")]',
        landCode: 'canoe',
        layer: 'kanuland',
        getTitle: () => html `Canoeing<br />in Switzer&#8203;land`,
        getTitleNoHyphen: () => html `Canoeing<br />in Switzer&#8203;land`,
        getFlatTitle: () => 'Canoeing in Switzerland',
        getLayerHintTitle: () => 'Canoeing in Switzerland routes',
        categories: nationalRegional,
        colorRGB: '#409698',
    },
    winterhike: {
        legacyLandCode: 'winterhiking',
        logoFilename: 'logos_winterhiking_segment.geojson',
        season: 'winter',
        colorClass: 'bg-winterhike',
        pageColorClass: 'bg-page-winterhike',
        logoClass: 'bg-[url("./src/img/logo_wi_h.svg")]',
        landCode: 'winterhike',
        layer: 'winterhiking',
        getTitle: () => html `Winter hiking<br />`,
        getTitleNoHyphen: () => 'Winter hiking',
        getFlatTitle: () => 'Winter hiking',
        getLayerHintTitle: () => 'Winter hiking paths',
        categories: winterCategories,
        colorRGB: '#EB6EA6',
    },
    snowshoe: {
        legacyLandCode: 'snowshoe',
        logoFilename: 'logos_snowshoe_segment.geojson',
        season: 'winter',
        colorClass: 'bg-snowshoe',
        pageColorClass: 'bg-page-snowshoe',
        logoClass: 'bg-[url("./src/img/logo_wi_s.svg")]',
        landCode: 'snowshoe',
        layer: 'snowshoe',
        getTitle: () => html `Snow&#8203;shoe trekking<br />`,
        getTitleNoHyphen: () => html `Snow&#8203;shoe trekking`,
        getFlatTitle: () => 'Snowshoe trekking',
        getLayerHintTitle: () => 'Snowshoe trekking trails',
        categories: winterCategories,
        colorRGB: '#BC5D8F',
    },
    crosscountry: {
        legacyLandCode: 'crosscountry',
        logoFilename: 'logos_crosscountry_segment.geojson',
        season: 'winter',
        colorClass: 'bg-crosscountry',
        pageColorClass: 'bg-page-crosscountry',
        logoClass: 'bg-[url("./src/img/logo_wi_c.svg")]',
        landCode: 'crosscountry',
        layer: 'crosscountry',
        getTitle: () => 'Cross-country skiing',
        getTitleNoHyphen: () => 'Cross-country skiing',
        getFlatTitle: () => 'Cross-country skiing',
        getLayerHintTitle: () => 'Cross-country skiing trails',
        categories: winterCategories,
        colorRGB: '#02A7DE',
    },
    sledge: {
        legacyLandCode: 'sledging',
        logoFilename: 'logos_sledging_segment.geojson',
        season: 'winter',
        colorClass: 'bg-sledge',
        pageColorClass: 'bg-page-sledge',
        logoClass: 'bg-[url("./src/img/logo_wi_sl.svg")]',
        landCode: 'sledge',
        layer: 'sledging',
        getTitle: () => 'Sledging',
        getTitleNoHyphen: () => 'Sledging',
        getFlatTitle: () => 'Sledging',
        getLayerHintTitle: () => 'Sledging runs',
        categories: winterCategories,
        colorRGB: '#9A6850',
    },
};
export const STATION_CODES = [
    'train',
    'bus',
    'trambus',
    'boat',
    'cableway',
    'funicular',
    'telecabin',
    'chairlift',
];
export const ACCOMMODATION_CODES = [
    'hotel',
    'bedbreakfast',
    'youthhostel',
    'backpacker',
    'groupaccom',
    'sleepingstraw',
    'farmaccom',
    'vacationapptmt',
    'mountainhut',
    'campingsite',
];
export const SERVICE_CODES = [
    'place',
    'sightseeing',
    'velorental',
    'cycleservice',
];
export const ADDITIONAL_LAYERTREE_CODES = [
    ...STATION_CODES,
    ...ACCOMMODATION_CODES,
    ...SERVICE_CODES,
    'wildlife',
    'alpguarddog',
    'slope',
    'snowdepth',
    'swisspark',
    'accommodation',
    'station',
    'slowup',
    'detour',
    'trackLayer',
    'municipalities',
    'cantons',
    'shooting',
];
export const SEASON_CODES = ['winter', 'summer'];
export const WS_ALIASES = {
    accomodation: 'accommodation',
    cycleservice: 'cycleservice',
    places: 'place',
    poi: 'sightseeing',
    rental: 'velorental',
};
export const LAND_LAYER_ORDER = [
    'hike.national',
    'hike.regional',
    'hike.local',
    'hike.handicap',
    'hike',
    'velo.national',
    'velo.regional',
    'velo.local',
    'velo',
    'mountainbike.national',
    'mountainbike.regional',
    'mountainbike.local',
    'mountainbike',
    'skate.national',
    'skate.regional',
    'skate.local',
    'skate',
    'canoe.national',
    'canoe.regional',
    'canoe.local',
    'canoe',
    'crosscountry.local',
    'crosscountry',
    'winterhike',
    'snowshoe',
    'sledge',
];
export const LAYER_ORDER = [
    'slowup',
    'station',
    ...STATION_CODES,
    'accommodation',
    ...ACCOMMODATION_CODES,
    'services',
    ...SERVICE_CODES,
    'detour',
    'shooting',
    ...LAND_LAYER_ORDER,
    'municipalities',
    'cantons',
    'slope',
    'swisspark',
    'alpguarddog',
    'wildlife',
    'wildlifearea',
    'wildlifereserve',
    'tour',
];
export const ADDITIONAL_LAYER_TYPES = [
    'accommodation',
    'velorental',
    'cycleservice',
    'bookable',
    'station',
    'swisspark',
    'slowup',
];
export const REGIONS = [
    { title: () => 'All', value: 0, default: true },
    { title: () => 'Aargau Region', value: 14 },
    { title: () => 'Bern Region', value: 6 },
    { title: () => 'Fribourg Region', value: 13 },
    { title: () => 'Zurich Region', value: 3 },
    { title: () => html `Jura & Three-Lakes`, value: 8 },
    { title: () => 'Geneva Region', value: 10 },
    { title: () => 'Lucerne - Lake Lucerne Region', value: 4 },
    { title: () => 'Eastern Switzerland / Liechtenstein', value: 2 },
    { title: () => 'Lake Geneva Region', value: 9 },
    { title: () => 'Basel Region', value: 5 },
    { title: () => 'Graubünden', value: 1 },
    { title: () => 'Valais', value: 11 },
    { title: () => 'Ticino', value: 12 },
];
export const CLUSTERED_LAYER_CODES = [
    ...STATION_CODES,
    ...ACCOMMODATION_CODES,
    ...SERVICE_CODES,
];
export const OVERLAY_LAYER_CODES = [
    ...CLUSTERED_LAYER_CODES,
    'alpguarddog',
    'slope',
    'wanderwegnetz',
    'wildlife',
    'slowup',
    'swisspark',
    'crosscountrynetwork',
    'winterhikingnetwork',
    'snowshoenetwork',
    'mtbnetwork',
    'velonetwork',
    'skatenetwork',
    'mtbnetwork_surface',
    'velonetwork_surface',
    'skatenetwork_surface',
    'mtbnetwork_grade',
    'velonetwork_grade',
    'skatenetwork_grade',
    'municipalities',
    'cantons',
    'snowdepth',
];
//# sourceMappingURL=layerConstants.js.map